<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'

import { useCreateCampaignRequest, useGetCampaignRequest } from '@/api'
import CampaignForm from '@/components/CampaignForm/CampaignForm.vue'
import HeaderComponent from '@/components/Navigation/HeaderComponent.vue'
import { notification } from '@/lib/helpers'
import type { CampaignFormType } from '@/lib/types/campaign.types'
import { useUserStore } from '@/stores/user'
import { LoadingComponent } from '@/ui-library'

const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const { createCampaign, isLoading, error } = useCreateCampaignRequest()
const { data: campaignData, isLoading: isCampaignLoading } = useGetCampaignRequest(Number(route.query.id as string))

const onCampaignCreate = async (data: CampaignFormType) => {
  await createCampaign(data)
  if (!error.value) {
    await router.push({ name: 'campaigns' })
    notification.success('The campaign was created successfully')
  }
}
</script>

<template>
  <HeaderComponent />
  <LoadingComponent v-if="isCampaignLoading || userStore.isLoading" :size="64" :is-full-size="true" />
  <template v-if="userStore.user">
    <CampaignForm
      v-if="campaignData"
      :is-loading="isLoading"
      :error="error"
      :campaign="campaignData"
      :default-advertiser-group-id="userStore.user.storeGroupId"
      @handle-submit="onCampaignCreate"
    />
  </template>
</template>
